export function updateQuestionOrderTransaction(tr,questionOrderArray){
	tr.doc.nodesBetween(0,tr.doc.content.size, (node, pos) => {
		if (node.type.name==='question') {
			tr.setNodeMarkup(pos, null, {...node.attrs,questionOrderArray:questionOrderArray})
		}
	})
	return tr
}